import { Schema } from "effect";
import { MessageAttachmentId } from "../../../../ids/definitions";

/**
 * Visibility level for attachments stored in S3
 * - public: File has a direct URL, accessible without authentication
 * - private: File requires a signed URL generated on-demand
 */
export const AttachmentVisibility = Schema.Literal("public", "private");
export type AttachmentVisibility = typeof AttachmentVisibility.Type;

/**
 * Attachment object returned to clients
 * Always includes a URL (presigned for private attachments)
 */
export const Attachment = Schema.Struct({
  id: MessageAttachmentId,
  url: Schema.String,
  description: Schema.OptionFromNullOr(Schema.String),
  mimeType: Schema.OptionFromNullOr(Schema.String),
});

export type Attachment = typeof Attachment.Type;
